import React from "react";
import "./sideProjects.scss";
import PropTypes from "prop-types";
import { Breakpoint } from "react-socks";
import Slider from "react-slick";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const Project = ({ project, index }) => {
  return (
    <div className="card pr-0">
      <div key={index}>
        <div className="card-inner">
          <header className="card-header">
            <h4 className="card-title text-3 ">
              <strong>{project.title}</strong>
            </h4>
            <h4 className="text-4 card-description">
              <strong>{project.description}</strong>
            </h4>
          </header>

          <footer className="card-footer w-100 my-auto">
            <div className="d-flex justify-content-center pt-5 mt-5">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="btn-view-my-work"
                href={project.githubLink}
              >
                <span>
                  <i className="fa fa-github"></i> Github
                </span>
              </a>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

Project.propTypes = {
  project: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

function SideProjects({ sideProjects }) {
  return (
    <div>
      <section id="side-projects" className="p-0">
        <h1 className="py-4 py-md-0 pb-md-4 title-2 title-md-2 section-heading">
          Personal projects
        </h1>

        <Breakpoint small down>
          <div className="card-container">
            <Slider {...settings}>
              {sideProjects.map((project, index) => {
                return <Project project={project} key={index} index={index} />;
              })}
            </Slider>
          </div>
        </Breakpoint>

        <Breakpoint medium up>
          <div className="card-container">
            {sideProjects.map((project, index) => {
              return <Project project={project} key={index} index={index} />;
            })}
          </div>
        </Breakpoint>

      </section>
    </div>
  );
}

SideProjects.propTypes = {
  sideProjects: PropTypes.array.isRequired,
};

export default SideProjects;
